import useOnScreen from "../../components/UseOnScreen/UseOnScreen"; 
import TypingEffect from "../../components/Animation/TypingEffect";
import "../Services/PersonalAnalysis.css";

const PersonalAnalysis = () => {
    const [aboutRef, isVisible] = useOnScreen({ threshold: 0.5, once: true });
    const analysisText = "Mesmo que a sua angústia ainda não tenha nome";

  return (
    <div id="personal-analysis" className="" ref={aboutRef}>
      <div className="analysis-container">
        <div className="analysis-first-text">
                {isVisible ? (
                        <>
                            <TypingEffect
                                text={analysisText}
                                speed={80}    
                                className="analysis-phrase"
                                />
                        </>
                    ) : (
                        <div className="placeholder-text">
                            <span className="analysis-phrase">{analysisText}</span>
                        </div>
                    )}
        </div>
        <div className="analysis-second-text">
          <h1>Análise Pessoal</h1>
          <span>A análise pessoal pode ser procurada em diversos momentos da vida, seja em
            situações de luto, separação, confusão, tristeza, experiências traumáticas , ou
            ainda questões com autoestima, compulsões entre outras. Orientada pela leitura
            lacaniana, se situa no campo da ética do desejo, permitindo que o sujeito se
            depare com suas alienações, seus impasses e a sua verdade. Cada sessão
            <strong> é uma travessia</strong>, um movimento onde a palavra circula, encontra
            barreiras e, por vezes, perfura o que parecia intocável. Nesse espaço, o sujeito
            tem a chance de se confrontar com aquilo que ainda não sabia que sabia sobre si
            mesmo,
            <strong>para inventar outra forma de se posicionar diante do mundo.</strong>
          </span>
        </div>
      </div>
    </div>
  );
}

export default PersonalAnalysis;
